import axlesService from '../../services/axlesServices';
import common, { CommonService } from '../../services/commonService';

class Pan {

  ptDrag: any = null;
  ptMouse: any = null;

  ptRectOrigin: any = null;


  ctrlKey: boolean = false;
  dragOffset: any = null;

  constructor() {
    this.ptDrag = null;
  }

  clear = () => {
    try {
    } catch (ex) {
      console.error('failed to clear:', ex);
    }
  };

  click = (evt: any) => {
    try {
    } catch(ex) {
      console.error('failed on click: ', ex);
    }
  };

  mouseDown = (evt: any) => {
    try {

      this.ctrlKey = false;
      this.dragOffset = null;


      const cnvs = axlesService.canvas;
      if (cnvs.hover && !this.ptRectOrigin) {
        var pts = cnvs.getSelectedTagPoints();
        if (pts) {
          cnvs.resizeIndex = pts.findIndex(p => this.pointsEqual(p, cnvs.hover));
          if (cnvs.resizeIndex < 0)
            cnvs.resizeIndex = null;
          return;
        }
      }

      this.ptDrag = this.getBoundedPoint(axlesService.canvas.getPoint(evt));
      const clickedTagged = cnvs.getClickedTag(evt);
      if (clickedTagged) {
        this.dragOffset = [this.ptDrag.x - clickedTagged.rect[0],this.ptDrag.y - clickedTagged.rect[1]];
        common.notify("AxlesTagSelected", clickedTagged);
      }

      this.ctrlKey = evt.ctrlKey;
      
    } catch(ex) {
      console.error('failed on mouseDown: ', ex);
    }
  };

  dragAnnotation = (evt: any) => {
    try {
      const cnvs = axlesService.canvas;
      const pt = cnvs.getPoint(evt);


      const tag = common.axles.tag;
      tag.rect[0] = pt.x - this.dragOffset[0];
      tag.rect[1] = pt.y - this.dragOffset[1];

      tag.rect = this.getBoundedRect(tag.rect);
      cnvs.paint("pan");
      common.axles.imageDirty = true;
    } catch (ex) {
      console.log('failed to drag annotation', ex);
    }
  }

  mouseMove = (evt: any) => {
    try {
      const cnvs = axlesService.canvas;
      if (cnvs.resizeIndex !== null) 
        return this.mouseResize(evt);
      
      if (this.ctrlKey)
        return this.dragAnnotation(evt);

      if (this.ptRectOrigin)
        return this.mouseAnnotate(evt);

      const pt = cnvs.getPoint(evt);
      const ptBounded = this.getBoundedPoint(pt);
      const outOfBounds = pt.x !== ptBounded.x || pt.y !== ptBounded.y;
      cnvs.mousePos = pt;
      if (this.ptDrag && !outOfBounds) {
        cnvs.ctx.translate((pt.x - this.ptDrag.x), (pt.y - this.ptDrag.y));
        cnvs.saveMatrix();
        return;
    }
    cnvs.hover = null;

    const pts = cnvs.getSelectedTagPoints();
    if (!pts)
      return;

    const r = axlesService.canvas.getAnchorRadius();
    pts.forEach((ptx:any) => {
      if (cnvs.getDistance(ptx, pt) < r) {
        cnvs.hover = ptx;
        return;
      }
    });

    } catch (ex) {
      console.error('failed on mouseMove:', ex);
    }
  };

  pointsEqual = (pt0: any | null, pt1: any | null) => {
    if (!pt0 || !pt1)
      return false;

    return pt0.x === pt1.x && pt0.y === pt1.y;
  }

  getBoundedPoint = (pt: any): any => {
    try {
      const size = axlesService.canvas.imageSize;
      const x = Math.min(Math.max(pt.x, 0), size[0] - 1);
      const y = Math.min( Math.max(pt.y, 0), size[1] - 1);
      return {x, y};
    } catch (ex) {
      console.error('failed to get bounded point:', ex);
      return pt;
    }
  }

  mouseResize = (evt:any) => {
    try {
      const cnvs = axlesService.canvas;
      const pts = cnvs.getSelectedTagPoints();
    
     
      const tag = common.axles.tag;
      if (!pts) return;
      const pt = this.getBoundedPoint(cnvs.getPoint(evt));
      switch (cnvs.resizeIndex) {
        case 0: {
          const l = pt.x;
          const t = pt.y;
          const w = pts[2].x - pt.x;
          const h = pts[2].y - pt.y;
          tag.rect = [l,t,w,h].map(x => Math.round(x));
          }
          break;

        case 1: {
          const l = pts[0].x;
          const t = pt.y;
          const w = pt.x - pts[0].x;
          const h = pts[2].y - pt.y;
          tag.rect = [l,t,w,h].map(x => Math.round(x));

       }
        break;
        case 2: {
          const l = pts[0].x;
          const t = pts[0].y;
          const w = pt.x - l;
          const h = pt.y - t;
          tag.rect = [l,t,w,h].map(x => Math.round(x));
       }
        break;

        case 3: {
          const l = pt.x;
          const t = pts[1].y;
          const w = pts[1].x - l;
          const h = pt.y - t;
          tag.rect = [l,t,w,h].map(x => Math.round(x));
        }
        break;

        case 4: {
          const l = pts[0].x;
          const t = pt.y;
          const w = pts[1].x - pts[0].x;
          const h = pts[2].y - pt.y;
          tag.rect = [l,t,w,h].map(x => Math.round(x));
        }
        break;

        case 5: {
          const l = pts[0].x;
          const t = pts[0].y;
          const w = pt.x - pts[0].x;
          const h = pts[2].y - pts[0].y;
          tag.rect = [l,t,w,h].map(x => Math.round(x));
        }
        break;

        case 6: {
          const l = pts[0].x;
          const t = pts[0].y;
          const w = pts[1].x - pts[0].x;
          const h = pt.y - pts[0].y;
          tag.rect = [l,t,w,h].map(x => Math.round(x));
        }
        break;

        case 7: {
          const l = pt.x;
          const t = pts[0].y;
          const w = pts[1].x - pt.x;
          const h = pts[2].y - pts[0].y;
          tag.rect = [l,t,w,h].map(x => Math.round(x));
        }
        break;




      }
      common.axles.imageDirty = true;

      if (pts && cnvs.resizeIndex !== null && cnvs.resizeIndex > -1) {
        const pts2 = cnvs.getPointsEx(tag.rect);
        cnvs.hover = pts2[cnvs.resizeIndex];
      }

      cnvs.paint("pan");

    } catch (ex) {
      console.error('failed on mouse resize', ex);
    }
  }

  getBoundedRect = (r: number[]): number[] => {
    try {
      const x = Math.max(r[0], 0);
      const y = Math.max(r[1], 0);
      const size = axlesService.canvas.imageSize;
      const w = Math.min(r[2], size[0] - x - 1);
      const h = Math.min(r[3], size[1] - y - 1);
      return [x,y,w,h ];
    } catch(ex) {
      console.error('failed to get bounded rect:', ex);
      return r;
      }
    }

  /**
   * axle annotation
   * @param evt 
   */
  mouseAnnotate = (evt: any) => {
    try {
      const pt = this.getBoundedPoint(axlesService.canvas.getPoint(evt));
      axlesService.canvas.mousePos = pt;
      const pt0 = this.ptRectOrigin;
      const x = Math.min(pt.x, pt0.x);
      const y = Math.min(pt.y, pt0.y);
      const w = Math.abs(pt.x - pt0.x);
      const h = Math.abs(pt.y - pt0.y);
      axlesService.canvas.hotRect = [x, y, w, h];
      // limit
      axlesService.canvas.hotRect = this.getBoundedRect(axlesService.canvas.hotRect);
      axlesService.canvas.paint("pan");
     
    } catch (ex) {
      console.error('failed on mouseMove');
    }
  };



  rectContains = (r: number[], pt: any): boolean => {
    try {
      return (r[0] < pt.x && r[1] < pt.y && r[0] + r[2] > pt.x && r[1] + r[3] > pt.y);
    } catch (ex) {
      console.log('failed on check containment:', ex);
      return false;
    }
  }

  /**
   * returns tag that contains the specified point, or null if point is outside tags
   * @param pt point to check
   * @returns 
   */
  getContainingTag = (pt: any) => {
    try {
      // all existing tags
      const tags = axlesService.canvas.getTags();
      if (!tags) 
        return null;

      return tags.find((t: any) => this.rectContains(t.rect, pt));
     
    } catch (ex) {
      console.log('failed to get containing tag:', ex);
    }
  } 

  inBounds = (pt: any) => {
    try {
      const size = axlesService.canvas.imageSize;
      if (pt.x < 0 || pt.y < 0)
        return false;

      if (pt.x > size[0] || pt.y > size[1])
        return false;

      return true;
    } catch (ex) {
      console.log('failed to control inBounds: ', ex);
      return false;
    }
  }

  /**
   * double click to start a new axle tag (with ctrl - a new cab tagging)
   * @param evt 
   * @returns 
   */
  doubleClick = (evt: any) => {
    try {
      const pt =  axlesService.canvas.getPoint(evt);

      // ignore double click outside
      if (!this.inBounds(pt))
        return; 

      // if double click inside an existing tag - ignore
      const containing = this.getContainingTag(pt);
      if (containing) 
        return;

      if (!common.axles.newTagType)
        return;

      this.ptRectOrigin = pt;

    } catch (ex) {
      console.error('failed on double click');
    }
  }

 getRect = (pt0:any, pt1: any): number[] => {
   try {
    const x = Math.min(pt0.x, pt1.x);
    const y = Math.min(pt0.y, pt1.y);
    const w = Math.abs(pt0.x - pt1.x);
    const h = Math.abs(pt0.y - pt1.y);
    return [x,y,w,h];
   } catch (ex) {
     console.error('failed to get rect:', ex);
     return [0,0,0,0];
   }
 }

  mouseUp = (evt: any) => {
    try {

      this.dragOffset = null;
      this.ctrlKey = false;

      if (this.ptRectOrigin && this.ptDrag) {
        var r = this.getRect(this.ptRectOrigin, this.ptDrag);
        common.notify('AxlesAddTag', r as any);
      }

      // after resize - normalize
      if (axlesService.canvas.resizeIndex !== null) {
        const tag = common.axles.tag;
        const r = tag.rect;
        tag.rect = [
          Math.min(r[0],r[0] + r[2]), 
          Math.min(r[1], r[1] + r[3]),
          Math.abs(r[2]),
          Math.abs(r[3])
            ];
        console.log('normalizing');
      }

      this.ptDrag = null;
      this.ptRectOrigin = null;
      axlesService.canvas.resizeIndex = null;
      axlesService.canvas.hotRect = null;
      axlesService.canvas.hotCabRect = null;
    
    

      // if (common.axles.dirty) 
      common.notify('AxleTagsChanged');

    } catch(ex) {
      console.error('failed on mouseUp: ', ex);
    }
  };

  mouseLeave = (evt: any) => {
    try {
      this.ptDrag = null;
      this.ptRectOrigin = null;
      axlesService.canvas.resizeIndex = null;

    } catch (ex) {
      console.error('failed to handle mouse leave');
    }
  }

  zoom = (clicks:number) => {
    try {
        const ctx = axlesService.canvas.ctx;
        const scaleFactor = 1.1;
        const pt = axlesService.canvas.mousePos;
        if (!pt)
          return;
          
        ctx.translate(pt.x, pt.y);
        const factor = Math.pow(scaleFactor, clicks);
        ctx.scale(factor, factor);
        ctx.translate(-pt.x, -pt.y);
        axlesService.canvas.saveMatrix();
      } catch (ex) {
        console.error('failed to zoom:', ex);
      }
    };

  mouseWheel = (evt: any) => {
    try {
      const delta = evt.nativeEvent.wheelDelta ? evt.nativeEvent.wheelDelta / 40 : evt.detail ? -evt.detail : 0;
      this.zoom(delta);
    } catch (ex) {
      console.error('failed to handle canvasMouseDown:', ex);
    }
  };


}

const pan: Pan = new Pan();

export default pan;